// Login.js
import "./Login.css";
import React, { useState } from "react";
import { useAuthContext } from "../context/AuthContext";
import { setToken } from "../helpers";
import { API } from "../constant";
import ButtonV2 from "./ButtonV2";

const Login = () => {
  const { setUser } = useAuthContext();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [incorrectLogin, setIncorrectLogin] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/auth/local`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ identifier, password }),
      });
      const data = await response.json();

      if (data.jwt) {
        setToken(data.jwt);
        setUser(data.user);
        // Přesměrování nebo další akce po přihlášení
        console.log("prihlaseni ok");
        setIncorrectLogin(false);
        console.log(data.jwt);
        // console.log(data.user);
      } else {
        console.log("chyba pri prihlaseni");
        setIncorrectLogin(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container mt-5 mb-5">
      <h2>Přihlášení</h2>
      <form className="login-form" onSubmit={(e) => e.preventDefault()}>
        <input
          type="text"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          placeholder="Uživatelské jméno"
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Heslo"
          required
        />
        {incorrectLogin && (
          <div className="error">Špatné přihlašovací údaje</div>
        )}
        <div
          onClick={() => {
            if (!isLoading) {
              handleLogin();
            }
          }}
          className="m-2 d-flex justify-content-center"
          style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
        >
          <ButtonV2 text={isLoading ? "Přihlašování..." : "Přihlásit se"} />
        </div>
      </form>
    </div>
  );
};

export default Login;
